<template>
  <v-list-item
    v-if="product"
    :disabled="disabled || productDisabled"
    @click.stop="onProductClick(product)"
  >
    <div
      class="pa-1 mr-3 mt-2 mb-auto"
      style="width: 132px; max-width: 132px; height: 100px;"
    >
      <v-img
        v-if="product.Image"
        :src="product.Image"
        class="rounded"
        height="90"
      />
      <div
        v-else
        class="brand-primary lighten-5 rounded text-center justify-center align-center d-inline-flex"
        style="width: 100%; height: 100%;"
      >
        <img
          v-if="!storeLogo && productStoreLogo"
          :src="productStoreLogo"
          style="width: 70px; height: auto; opacity: 0.20;"
        >
        <img
          v-else
          :src="LogoDarkPng"
          style="width: 70px; height: auto; opacity: 0.20;"
        >
      </div>

      <v-avatar
        v-if="storeLogo && productStoreLogo"
        size="28"
        style="position: absolute; top: 3px; left: 3px;"
      >
        <img :src="productStoreLogo">
      </v-avatar>
    </div>

    <v-list-item-content class="align-content-space-between">
      <div class="align-center">
        <v-list-item-title>
          <product-quantity
            v-if="showProductQuantity"
            :product="product"
          />

          {{ productName }}
        </v-list-item-title>

        <v-list-item-subtitle class="brand-grey--text brand-text-small mt-1">
          {{ cartProductSelectedOptions }}
        </v-list-item-subtitle>
      </div>

      <div class="d-flex align-center">
        <product-price
          :product="product"
          auto-calculate
          cart
          class="brand-text-small"
        />

        <v-spacer />

        <product-tags
          v-if="showProductTags"
          :tags="product.Tags"
          icon-only
          small
          style="position:absolute; bottom: 10px; right: 14px;"
        />
      </div>
    </v-list-item-content>

    <v-list-item-action>
      <product-cart-quantity-selector
        v-model="productQuantity"
        :max="productMaxQuantity"
        :min="productMinQuantity"
        :product="product"
        :step="productQuantityStep"
        :unit-id="selectedProduct.UnitId"
        quantity-animation
      />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import CartProductListItemMixin from '@/theme/default/components/cart/CartProductListItem.js'

export default {
  name  : 'CartProductListItem',
  mixins: [CartProductListItemMixin]
}
</script>

<style scoped src="@/theme/default/components/cart/CartProductListItem.css"></style>

<style scoped>
</style>
